import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationOvershoot: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnimationOvershoot"><Path d="M3.51755 20.5C3.51755 20.5 2.98681 1.12516 7.76311 3.74331C12.5394 6.36146 14.6623 6.88515 20.5 6.88515" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnimationOvershoot;
